// extracted by mini-css-extract-plugin
module.exports = {"container":"searchInput_container__3IHit","input":"searchInput_input__gOuNW"};